import { defineStore } from 'pinia'
import { CHAT_LIST_TAB } from '../constants/chat'
import { setChatViewStoreAccessor } from './chatStoreSync'
import type { ChatViewState } from './view/actionsContext'
import { reactionActions } from './view/reactionActions'
import { syncActions } from './view/syncActions'
import { listActions } from './view/listActions'
import { openChatActions } from './view/openChatActions'
import { activeChatActions } from './view/activeChatActions'
import { sendActions } from './view/sendActions'
import { permissionActions } from './view/permissionActions'

export const useChatStore = defineStore('matrixChatFast', {
  state: (): ChatViewState => ({
    contacts: [],
    chatsContacts: [],
    profileUser: undefined,
    activeChat: null,
    chatListTab: CHAT_LIST_TAB.EMPLOYEES,
    isLoading: false,
    isLoadingChat: false,
    isScrollingToBottom: false,
    messageRateLimiter: null,
    fileMessageRateLimiter: null,
    lastMessageReaders: null,
  }),
  actions: {
    ...reactionActions,
    ...syncActions,
    ...listActions,
    ...openChatActions,
    ...activeChatActions,
    ...sendActions,
    ...permissionActions,
  },
})

setChatViewStoreAccessor(() => useChatStore())
